import {ApiSlice} from "@/store/ApiSlice";
import RESTAPIConfig from "@/config/RESTAPIConfig";
import {CurrentUserMenuInterface} from "@/api/Settings/MenuSettings/MenuInterfaces";

const restApiConfig = new RESTAPIConfig();

export const GetCurrentUserMenuApiSlice = ApiSlice.injectEndpoints({
    endpoints: builder => ({
        getCurrentUserMenu: builder.query<CurrentUserMenuInterface, void>({
            query: () => ({
                url: restApiConfig.baseUrl + restApiConfig.apiPrefixV2 + restApiConfig.currentUserMenu(),
            }),
            providesTags: ["FetchedData", "CurrentUserMenu", "CurrentUser"],
            keepUnusedDataFor: 300,
        })
    })
});

export const {useGetCurrentUserMenuQuery} = GetCurrentUserMenuApiSlice;
